import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard } from '@principle-theorem/shared';
import { isString } from 'lodash';
import { STERILISATION_MACHINE_RESOURCE_TYPE } from '../../../mappings/sterilisation-machine';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';

export const STERILISATION_MACHINE_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Sterilisation Machine List',
    description: '',
    idPrefix: STERILISATION_MACHINE_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ICorePracticeSterilisationMachine {
  name: string; // "Lisa 1"
}

export function isCorePracticeSterilisationMachine(
  item: unknown,
  logError: boolean
): item is ICorePracticeSterilisationMachine {
  return TypeGuard.interface<ICorePracticeSterilisationMachine>(
    { name: isString },
    logError
  )(item);
}

/**
 * Core Practice has no steriliser table; machines only exist as free text
 * on each tracking row, so the name doubles as the identifier.
 */
const STERILISATION_MACHINE_SOURCE_QUERY = `
SELECT DISTINCT Steriliser AS name
FROM tblSteriTracking
WHERE Steriliser <> ''
ORDER BY name
`;

export type CorePracticeSterilisationMachine =
  ISourceEntityTypes<ICorePracticeSterilisationMachine>;

export class SterilisationMachineSourceEntity extends BaseSourceEntity<CorePracticeSterilisationMachine> {
  sourceEntity = STERILISATION_MACHINE_SOURCE_ENTITY;
  entityResourceType = STERILISATION_MACHINE_RESOURCE_TYPE;
  sourceQuery = STERILISATION_MACHINE_SOURCE_QUERY;
  verifySourceFn = isCorePracticeSterilisationMachine;

  translate(): object {
    return {};
  }

  getSourceRecordId(data: ICorePracticeSterilisationMachine): string {
    return data.name;
  }

  getSourceLabel(data: ICorePracticeSterilisationMachine): string {
    return data.name;
  }

  getFilterData(): object {
    return {};
  }
}
